import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";

const Hero = () => {
  const reduce = useReducedMotion();

  return (
    <section id="inicio" data-testid="hero-section" className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-14 md:pt-20 pb-16 md:pb-24 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal>
          <span
            data-testid="hero-badge"
            className="inline-flex items-center gap-2 bg-brand-pink/10 text-brand-pink text-xs md:text-sm font-semibold rounded-full px-4 py-2 uppercase tracking-wide"
          >
            ¡Estamos abiertos!
          </span>
          <h1 className="text-balance mt-6 font-display font-bold tracking-tight text-brand-charcoal text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
            LA VIDA ES <span className="text-brand-pink">CROC.</span>
          </h1>
          <p className="mt-6 text-base md:text-lg text-brand-charcoal/75 leading-relaxed max-w-xl">
            CROC LAB nace en Valencia para hacer una cosa muy simple: que cada
            bocado suene. Crujiente por fuera. Brutal por dentro.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              data-testid="hero-cta-locales"
              href="https://maps.app.goo.gl/3ZcPNSGucypFjynt5"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-brand-pink text-white font-semibold rounded-full px-8 py-3.5 hover:bg-brand-pink/90 hover:scale-105 transition-transform"
            >
              <MapPin className="w-4 h-4" aria-hidden="true" />
              Encuentra tu Croc
            </a>
            <a
              data-testid="hero-cta-carta"
              href="#carta"
              className="inline-flex items-center justify-center gap-2 border-2 border-brand-charcoal text-brand-charcoal font-semibold rounded-full px-8 py-3.5 hover:bg-brand-charcoal hover:text-white transition-colors"
            >
              Descubre la carta
              <ArrowRight className="w-4 h-4" aria-hidden="true" />
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.15} className="relative flex justify-center lg:justify-end">
          <div className="relative w-64 md:w-80 lg:w-96 aspect-square">
            <div className="absolute inset-0 bg-brand-pink/15 rounded-full" aria-hidden="true" />
            <div
              className={`absolute -inset-3 md:-inset-5 rounded-full border-2 border-dashed border-brand-pink/50 ${reduce ? "" : "animate-croc-spin"}`}
              aria-hidden="true"
            />
            <motion.img
              src="/brand/croc-mascot.png"
              alt="Mascota de CROC LAB: un cerdito rosa guiñando un ojo"
              data-testid="hero-mascot-image"
              className="relative w-full h-auto rounded-full drop-shadow-xl"
              animate={reduce ? undefined : { y: [0, -12, 0] }}
              whileHover={reduce ? undefined : { rotate: -4, scale: 1.03 }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            />
            <span
              data-testid="hero-mascot-sticker"
              className="absolute -top-1 -right-1 md:top-2 md:right-0 bg-brand-charcoal text-white text-xs md:text-sm font-display font-semibold rounded-full px-4 py-2 rotate-6 shadow-lg"
            >
              Crocca sin reglas
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
